import { Flex } from "@aircall/tractor";
import styled, { css, getColor, getSpace } from "@xstyled/styled-components";

export const OuterLayout = styled(Flex)<{
  shrink: boolean;
  mobile: boolean;
}>`
  flex: 1;
  flex-direction: column;

  // minWidth=0 allow left columns to shrink, it's important to let the right column take full screen
  min-width: ${({ shrink, mobile }) => {
    if (shrink) {
      return "0";
    }
    if (mobile) {
      return "0";
    }
    return "576px";
  }};
  @media (min-width: md) and (max-width: xl) {
    min-width: ${({ shrink, mobile }) => {
      if (shrink) {
        return "0";
      }
      if (mobile) {
        return "0";
      }
      return "50%";
    }};
  }
  margin: ${({ shrink }) => (shrink ? "0" : getSpace("xs"))};
  opacity: ${({ shrink }) => (shrink ? "0" : 1)};
  background-color: surface-default;

  transition: opacity 0.25s ease-in-out, margin 0.3s ease-in-out,
    padding 0.3s ease-in-out;

  // Hides the scrollbar so that it does not overflow
  overflow: initial;
  scrollbar-gutter: stable;
  border-radius: 16px;
  border: ${({ shrink }) => {
    if (shrink) {
      return "none";
    }

    return css`
      1px solid ${getColor("graphic-default")};
      `;
  }};
`;

// TODO: We might want to add some shadow when the content is scrollable.
export const InnerLayout = styled(Flex)`
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;
